<template>
  <div class="def-pass-container">
    <!--def-top-title str-->
    <div class="def-top-title">
      <div class="def-big-title">
        <h2>登录</h2>
      </div>
      <div class="def-sub-title">
        <!-- <p>登录测试页面</p> -->
      </div>
    </div>
    <!--def-top-title end-->
    <div class="def-pass-form">
      <div class="form-row">
        <div class="row-icon">
          <img src="../assets/images/icon-phone.png" alt=""/>
        </div>
        <div class="row-inp">
          <input type="text" class="r-inp" name="phone" v-model="phone" placeholder="请输入账号"/>
        </div>
      </div>
      <div class="form-row">
        <div class="row-icon">
          <img src="../assets/images/icon-def-pwd.png" alt=""/>
        </div>
        <div class="row-inp">
          <input type="password" class="r-inp" name="pwd" v-model="pwd" placeholder="请输入密码"/>
        </div>
      </div>
    </div>
    <div class="def-pass-btn">
      <a href="javascript:;" class="active" @click="login()">登录</a>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';
  import md5 from '@/utils/md5'
  export default {
    name: "login",
    data() {
      return {
        phone: '13300000001',
        pwd: 'a123456'
      }
    },
    mounted() {

    },
    methods: {
      login() {
        if (!this.phone) {
          this.$toast('请输入账号');
          return false;
        }
        if (!this.pwd) {
          this.$toast('请输入密码');
          return false;
        }
        this.$store.dispatch('Login', {
          phone: this.phone,
          password: this.pwd,
          deviceType:"03",
          deviceToken:"15606974151",
          deviceId:"123",
          openId:"o4Ma2t76hX2tdiOyVzElgolduD7g"
        }).then(res=>{
          var imUserExtra = JSON.parse(res.userIm.imUserExtra);
          //模拟存储云信登录账号
          // Cookies.set('uid', "user1")
          // Cookies.set('sdktoken', md5("123456"))
          Cookies.set('uid', imUserExtra.accid)
          Cookies.set('sdktoken', imUserExtra.token)
          Cookies.set('sessionId', res.sessionId)
          Cookies.set('imDoctorId', imUserExtra.accid);
          sessionStorage.setItem('userEnter', 'doctor')
          this.$toast('登录成功');
          setTimeout(()=>{
            this.$router.push({ path: "/imIndex"});
          }, 2000)
        }).catch(err=>{
          console.log(err);
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login.vue